import React from 'react';
import { PageLayoutTemplate } from 'themes/layouts';

const PageLayout = function (props) {
    return <PageLayoutTemplate {...props} />;
};

export default PageLayout;
